<template>
  <div class="tenant-management">
    <breadCrumb></breadCrumb>
    <div class="tenant-management-header"><button @click="addTenant">+新增</button></div>
    <div class="tenant-management-table">
      <base-table :tableData="tableData"  @cancelAdmin="cancelAdmin" @handleClick="handleClick"></base-table>
    </div>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    > </pagination>
    <new-role-dialog 
      :dialogFormVisible="dialogFormVisible" 
      :checkboxList="checkboxList" 
      @changeDialog="changeDialog" 
      :formData="dialogForm" 
      @submit="submit" 
      :parentList="parentList">
    </new-role-dialog>
    <modal
      :isShow.sync="ifdialogFormVisible"
      :isShowClose="true"
      :title="dialogTitle"
      :btnText="butText"
      :types="types"
      :isShowBtn="isShowBtn"
      @clickHandler="clickHandler"
    >
    <div class="dialogVal">
      是否确认取消{{tenantName}}的租户权限
    </div>
    </modal>
  </div>
</template>

<script>
  import pagination from "../../../../components/pagination"
  import baseTable from "../../../../components/baseTable";
  import newRoleDialog from "../../components/newRoleDialog";
  // import dialogForm from "../../../../components/dialogForm"
  import modal from "../../../../components/modal"
  import breadCrumb from "../../../../components/breadCrumb";
  import {tenantPage,disableContentTenant,listPermissionTree,tenantAdd,tenantDetail ,tenantUpdate} from '../../../../api/admin'
  export default {
    name: "tenantManagement",
    components:{
      baseTable,
      newRoleDialog,
      // dialogForm,
      modal,
      pagination,
      breadCrumb,
    },
    data(){
      return{
        dialogForm: {
          name: '',
          tenantType: '',
          tenantManagerPermissionDTOList:[],
          // chekcedPermissionIdStr:''
        },
        tenantName:'',
        ifdialogFormVisible:false,
        dialogTitle:'提示',
        butText:['取消','确认'],
        types:['default','submit'],
        isShowBtn:[true,true],
        checkboxList:[],
        isUpdata:true,
      //   formDataList:[
      //   {
      //     label: "租户名称",
      //     type: "input",
      //     prop: "tenement",
      //   },
      //   {
      //     label: "租户类型",
      //     type: "select",
      //     prop: "tenementType",
      //     selectList:[]
      //   },
      // ],
      // maxlengths:'50',
        parentList:[],
        tableData:{
          tableList:[],
          
          tableHeader:[
            {
              prop:'id',
              label:'租户ID'
            },
            {
              prop:'name',
              label:'租户名称'
            },
            {
              prop:'tenantType',
              label:'租户类型'
            },
            {
              prop:'urlFlag',
              label:'租户登录链接'
            },
            {
              prop:'updateTime',
              label:'创建时间'
            },
            {
              prop:'createUser',
              label:'创建人'
            },
            {
              prop:'tenantStatus',
              label:'状态',
              tableStatus:'tenantStatus'
            }
            ],
          tableType: 3
        },
        tabValue:{},
        dialogFormVisible:false,
        val:{},
        paginationDataProduct: {
          total: 0,
          currentPage: 1,
          pageSize: 10
        },
      }
    },
    created() {
      this.tenantPage()
      this.listPermissionTree()
    },
    methods:{
      // 分页器
      paginationChangeProduct(val){
        
        this.paginationDataProduct = val
        this.tenantPage()
      },
      clickHandler(val){
        if(val === 'one'){
          this.ifdialogFormVisible = false
        }else{
          this.disableContentTenant(this.val.id)
          this.ifdialogFormVisible = false
        }
        
        
        // 
      },
      addTenant(){
        this.isUpdata = true
        
        
        // this.$refs.tenant.resetFields();
        this.dialogForm.name = ''
        this.dialogForm.tenantType = ''
        this.parentList = []
        this.dialogFormVisible = true
      },
      cancelAdmin(val){
        this.tenantName = val.name
        this.ifdialogFormVisible = true
        // 
        this.val = val
      },
      // 编辑
      tenantDetail(val){
        tenantDetail(val)
        .then(res => {
          
          this.dialogFormVisible = true
          this.dialogForm.name = res.name 
          this.dialogForm.tenantType = res.tenantType 
          let arrId = res.tenantManagerPermissionDTOList.map(item => {
            return item.id
          })
          this.parentList = arrId
          
        })
      },
      handleClick(val){
        this.tabValue = val.val
        
        // this.$refs.tenants.resetFields();
        if(val.type === 'edit'){
          this.isUpdata = false
          
          
          
          this.tenantDetail({id:val.val.id})
        }else if(val.type === 'goAdmin'){
          this.$router.push({
            path:'admin',
            query:val.val
          })
        }
      },
      changeDialog(){
        this.dialogFormVisible = false
      },
      goAdmin(){
        
        
      },
      // 取消租户
      disableContentTenant(val){
        let vm =this
        disableContentTenant({
          id:val
        })
        .then(res => {
          vm.tenantPage()
        })
      },
      tenantPage(){
        let vm = this
        tenantPage({
          page:this.paginationDataProduct.currentPage,
          pageSize:this.paginationDataProduct.pageSize,
          tenantStatus:''
        })
        .then(res => {
          
          vm.paginationDataProduct.total = res.totalCount 
          vm.paginationDataProduct.currentPage = res.pageNo
          vm.paginationDataProduct.pageSize = res.pageSize 
          vm.tableData.tableList.splice(0,vm.tableData.tableList.length)
          res.data.map(item => {
            if(item.tenantManagerPermissionDTOList !== null){
              let tUrl = item.tenantManagerPermissionDTOList.map(item1 => {
                return item1.id
              })
              item.toUrl = tUrl[0]
            }
            vm.tableData.tableList.push(item)
          })
          // 
        })
        
      },
      submit(data){
        
        if(this.isUpdata){
          let arr = data.parentId.concat(data.listId)
          this.dialogForm.chekcedPermissionIdStr = arr.join(',')
          
          this.tenantAdd({
            name:this.dialogForm.name,
            tenantType:this.dialogForm.tenantType,
            chekcedPermissionIdStr:this.dialogForm.chekcedPermissionIdStr
          })  
          this.dialogFormVisible = false
        }else{
          this.dialogFormVisible = false
          let arr = data.parentId.concat(data.listId)
          this.dialogForm.chekcedPermissionIdStr = arr.join(',')
          this.tenantUpdate(this.tabValue.id,this.dialogForm.chekcedPermissionIdStr,this.dialogForm.tenantType,this.dialogForm.name,)
        }


      },
      // 更新
      tenantUpdate(id,list,tenantType,name){
      tenantUpdate(
        {
          id:id,
          chekcedPermissionIdStr:list,
          tenantType:tenantType,
          name:name
        }
      )
      .then(res => {
        
        this.tenantPage()
      })
    },
      // 添加
      tenantAdd(val){
        
        tenantAdd(val)
        .then(res => {
          
          this.tenantPage()
          // if(res.msg === "OK"){
            
          // }
        })
        .catch(err => {
          
          if(err.code === '0023'){
              this.$message.error('租户已存在，不可重复添加');
          }
        })
      },
      listPermissionTree(){
        let vm = this
        listPermissionTree({})
        .then(res => {
          
          if(this.dialogForm.tenantManagerPermissionDTOList !== null){
            res.map(item => {
              this.dialogForm.tenantManagerPermissionDTOList.push({
                id:'',
                contentPermissionDTOs:[],
                listId:[]
              })
            })
          }
          vm.checkboxList = res
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .tenant-management{

  }
  .dialogVal{
    color: #5F5F6B;
    font-weight: 600;
    font-size: 16px;
    padding: 30px 0px;
    padding-bottom: 0px;
    text-align: center;
  }
</style>
